import { connect } from 'react-redux';
import {
  getLabels,
  getMetainf,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getUnitsExecutionState,
} from '../../../reducers/analyticsApp';
import RevenuePreview from '../../../components/dashboards/preview/RevenuePreview';
import { revenueQueryTypes, revenueQueryTypesView } from '../../../constants/revenue';
import { commonEvents } from '../../../constants/event';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const { options } = unit.compose.revenue;
  const revenueType = revenueQueryTypesView[unit.compose.revenue.queryType];

  return {
    result: unitExecute.events || [],
    executeTime: unitExecute.executeTime,
    timezone: getProjectZoneId(state),
    zoneId: getProjectOriginalZoneId(state),
    userZoneId: getProjectZoneId(state),
    options,
    revenueType,
    labels: getLabels(state),
    metainf:
      revenueType === revenueQueryTypes.ARPU || revenueType === revenueQueryTypes.PAYERS
        ? getMetainf(state)
        : getMetainf(state, commonEvents.PAYMENT),
    unit,
  };
};

export default connect(mapStateToProps)(RevenuePreview);
